// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

import { useQuery } from '@tanstack/react-query';

import { useEnhancedRpcClient } from '~/hooks/useEnhancedRpc';

export function useGetNetworkMetrics() {
	// Metrics methods (safex_*) are served by the indexer, not the bare fullnode,
	// so use the enhanced RPC client (points at /indexer).
	const client = useEnhancedRpcClient();
	return useQuery({
		queryKey: ['home', 'metrics'],
		queryFn: () => client.getNetworkMetrics(),
		gcTime: 24 * 60 * 60 * 1000,
		// Real-time network activity (TPS, current checkpoint/epoch, totals): poll every 10s.
		staleTime: 10 * 1000,
		refetchInterval: 10 * 1000,
		retry: 5,
	});
}
